import DownloadIcon from '@/app/_components/ui/icons/DownloadIcon.svg';
import Image from 'next/image';
import { useState } from 'react';

export default function DownloadBox({ data }) {
  const [iconColor, setIconColor] = useState('#fff');

  const handleHover = () => {
    setIconColor('#2A75BB');
  };

  const handleUnhover = () => {
    setIconColor('#fff');
  };

  const downloadHandler = (fileUrl, name) => {
    // Trigger download using anchor tag
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', name);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  if (data.price_list.path != '' || data.catalogue.path != '') {
    return (
      <div className="spContactWrap bg-white  rounded-sm pb-2 ">
        <div className="border  border-primary-100 bg-primary-5 p-4 rounded-md">
          <div className="flex ">
            <div className="expertImg">
              <Image
                src="/images/download-box.png"
                width="60"
                height="60"
                alt={'download-box'}
                className="rounded-full"
              />
            </div>
            <div className="pr-2">
              <div className="text-sm  text-slate-900 font-bold">
                دانلود باکس
              </div>
              <div className="text-xs text-slate-900 pt-2.5">
                فایل های مرتبط با این دسته‌بندی
              </div>
            </div>
          </div>
          <div className="flex mt-2 text-xs -mx-2">
            {data.price_list.path != '' && (
              <div className="flex-1 px-2">
                <button
                  onClick={() =>
                    downloadHandler(data.price_list.path, 'price_list')
                  }
                  onMouseEnter={handleHover}
                  onMouseLeave={handleUnhover}
                  className=" w-full bg-ocean-blue border rounded-md border-ocean-blue text-white  hover:bg-white hover:text-ocean-blue transition-all duration-200 flex py-2 justify-center "
                >
                  <DownloadIcon fill={iconColor} />
                  <span className=" whitespace-nowrap pr-1.5 ">لیست قیمت </span>
                </button>
              </div>
            )}
            {data.catalogue.path != '' && (
              <div className="flex-1 px-2 ">
                <button
                  onClick={() =>
                    downloadHandler(data.catalogue.path, 'catalogue')
                  }
                  className=" w-full bg-logo-yellow border border-logo-yellow text-color-black-primary rounded-md flex py-2 justify-center hover:bg-white hover:text-black-primary hover:border-logo-yellow transition-all duration-200 "
                >
                  <DownloadIcon fill={'#111111'} />
                  <span className=" whitespace-nowrap pr-1.5 ">
                    کاتالوگ برند
                  </span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
